import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ChartComponent = () => {
  const chartData = {
    labels: ["اسفند", "بهمن", "دی", "اذر", "ابان", "مهر"],
    datasets: [
      {
        label: "فروش",
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: "#7096CB"
      },
      {
        label: 'مخارج',
        data: [8, 10, 6, 4, 3, 2],
        backgroundColor: '#7096cb5b',
      },
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: true,
        text: "گزارش نیمه دوم سال"
      },
      scales: {
        x: {
          type: "category",
          grid: {
            display: true
          }
        },
        y: {
          grid: {
            display: true
          },
          ticks: {
            beginAtZero: true
          }
        }
      }
    }
  };

  return <Bar data={chartData} options={chartOptions} />;
};

export default ChartComponent;